import BaseClient from '../base/baseClient';
import endpoint from '../../features/endPoints/ecommEndpoints';
const paymentStatusClient = async (requestBody) => {
     const { post: postClient } = BaseClient();
     const payload ={
  "items": requestBody
}
    try {
          return await postClient(process.env.REACT_APP_ECOMM_URL + endpoint.OTpaymentStatus(), payload, {}, true);
    } catch (error) {
        return { error: error.message || "Error fetching payment status" };
    }
};

export default paymentStatusClient;

